import { sanitizeUrl, sanitizeFilename } from './utils/sanitize';

function forceDownload(blob, filename) {
    // Validar e sanitizar filename para prevenir XSS
    const safeFilename = sanitizeFilename(filename);

    // Validar que blob é uma URL válida (blob: ou data:)
    if (!blob || typeof blob !== 'string') {
        console.error('Invalid blob URL');
        return;
    }

    // Permitir apenas blob: URLs para downloads seguros
    if (!blob.startsWith('blob:')) {
        console.error('Only blob URLs are allowed for download');
        return;
    }

    const a = document.createElement('a');
    a.download = safeFilename;
    a.href = blob;

    // Usar click() sem appendChild para evitar XSS
    // appendChild não é necessário no DOM moderno
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();

    // Limpeza imediata
    setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blob);
    }, 100);
}

function downloadResource(url, filename) {
    // Validar URL para prevenir SSRF e XSS
    const safeUrl = sanitizeUrl(url);
    if (!safeUrl) {
        console.error('Invalid or unsafe URL:', url);
        return;
    }

    // Extrair filename de forma segura
    let safeFilename = filename;
    if (!safeFilename) {
        const urlParts = safeUrl.split('\\').pop().split('/').pop();
        safeFilename = sanitizeFilename(urlParts);
    } else {
        safeFilename = sanitizeFilename(filename);
    }

    fetch(safeUrl, {
        headers: new Headers({
            'Origin': window.location.origin
        }),
        mode: 'cors'
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.blob();
        })
        .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            forceDownload(blobUrl, safeFilename);
        })
        .catch(e => {
            console.error('Download error:', e);
        });
}

export { downloadResource }